import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { AzureIntegrationView } from "../gql";
import { USED_BY_COLUMN_ID } from "./constants";

const sortStacks = (
  items: AzureIntegrationView["attachedStacks"],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (sortDescriptor.column as USED_BY_COLUMN_ID) {
      case USED_BY_COLUMN_ID.TYPE:
        valueA = a.isModule ? "Module" : "Stack";
        valueB = b.isModule ? "Module" : "Stack";
        break;
      case USED_BY_COLUMN_ID.NAME:
        valueA = a.stackName;
        valueB = b.stackName;
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};

export const useFilteredStacks = (
  stacks: AzureIntegrationView["attachedStacks"],
  sortDescriptor: SortDescriptor,
  searchQuery: string
) => {
  return useMemo(() => {
    let filteredStacks = [...stacks];

    // Apply search filter if exists
    if (searchQuery) {
      filteredStacks = filteredStacks.filter((stack) =>
        stack.stackName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply sorting if descriptor exists
    if (sortDescriptor.column) {
      filteredStacks = sortStacks(filteredStacks, sortDescriptor);
    }

    return filteredStacks;
  }, [stacks, searchQuery, sortDescriptor]);
};
